import React from 'react';

/* Translations */
import { useTranslation } from 'react-i18next';

/* Components */
import { Switcher } from 'lego-dist';

/* Styled Components */
import {
  PermissionItemToggle,
  PermissionTitle,
  PermissionText,
  SwitcherWrapper,
} from '../styles/PermissionContainer';

/* Constants, Hooks, Services */
import usePermission from 'hooks/usePermission';

interface PermissionsWithToggleProps {
  handleEdit: any;
  checkPermission: any;
}

const PermissionsWithToggle = ({
  handleEdit,
  checkPermission,
}: PermissionsWithToggleProps) => {
  const { t } = useTranslation();
  const { permissionsList } = usePermission();

  return (
    <>
      {
        permissionsList.map((item: any, index: number) => {
          const { id, name } = item;
          return (
            <PermissionItemToggle key={id}>
              <div>
                <PermissionTitle>
                  {t(
                    'settings:STAFF_SECTION.MANAGE.ADD_MEMBER_VIEW.STEPS.PERMISSIONS.PERMISSION',
                  )}{' '}
                  {index + 1}
                </PermissionTitle>
                <PermissionText>{name}</PermissionText>
              </div>
              <SwitcherWrapper>
                <Switcher
                  theme="Pill"
                  enabled={checkPermission(id)}
                  onChange={() => handleEdit(id)}
                />
              </SwitcherWrapper>
            </PermissionItemToggle>
          );
        })
      }
    </>
  );
};

export default PermissionsWithToggle;
